/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type PatientResponsibilityUpdatedPayloadSideEffectType =
  (typeof PatientResponsibilityUpdatedPayloadSideEffectType)[keyof typeof PatientResponsibilityUpdatedPayloadSideEffectType];

export const PatientResponsibilityUpdatedPayloadSideEffectType = {
  patient_responsibility_updated: "patient_responsibility_updated",
} as const;
